import React, {useState, useEffect} from 'react';
import { motion } from 'framer-motion';
import './About.scss';
import {AppWrap, MotionWrap} from '../../wrapper';

import { urlFor, client } from '../../client';


const About = () => {

  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';
    client.fetch(query)
      .then((data)=>setAbouts(data))
  }, []);
  

  return (
    <>
      <h2 className='head-text'> I Know That <span> Good Development </span><br /> Means <span> Good Bussiness </span></h2>
      <p className='about-para'>Enthusiastic and results-driven, I am a highly skilled professional with a passion for technology and a proven track record in programming, full-stack development, and cutting-edge technologies such as AI, ML, and Data Science. Proficient in Java, C++, and Python, I have successfully delivered 10 plus projects and demonstrated my capabilities in both front-end and back-end development. My expertise spans a wide range of frameworks and tools, coupled with a strong foundation in databases, including SQL and MongoDB. With an Honours degree in AI-ML and a published paper in Springer Publication, I bring a unique blend of academic excellence and practical experience. My positive attitude, effective communication skills, and ability to lead State level events showcase my leadership qualities. Excited about leveraging my skills to contribute meaningfully to innovative projects, I am confident in my ability to bring a proactive and collaborative approach to any team or project.
      </p>
      <div className='app__profiles'>
        {abouts.map((about, index)=>(
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{duration:0.5, type: 'tween'}}
            className='app__profile-item'
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className='bold-text' style={{marginTop:20}}>{about.title}</h2>
            <p className='p-text' style={{marginTop:10}}>{about.description}</p>
          </motion.div>
        ))}
      </div>


    </>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  "app__whitebg"
  
);